import { Input, Button, Select, Space, Switch, Card } from "antd";
import { useState } from "react";

import SelectOptions from "./SelectOptions";
import { showNotification } from "../../../utils/notification";

const OPTIONS_DEPENDENT_QUESTION_TYPES = [
  "MULTIPLE_CHOICE_SINGLE_SELECT",
  "MULTIPLE_CHOICE_MULTI_SELECT"
];

const QuestionGeneratorForm = ({
  surveyQuestions,
  questionTypes = [],
  setSurveyQuestions = () => {},
  setAddNewQuestion = () => {}
}) => {
  const [questionType, setQuestionType] = useState("TEXT");
  const [questionTitle, setQuestionTitle] = useState("");
  const [displayOrder, setDisplayOrder] = useState(surveyQuestions.length + 1);

  const [options, setOptions] = useState([]);
  const [required, setRequired] = useState(false);

  const onChange = (checked) => {
    setRequired(checked);
  };

  const handleAddQuestion = () => {
    if (!questionTitle || questionTitle?.length < 5) {
      showNotification("Question Title is required", "Please enter the title", "error");
      return;
    }
    if (OPTIONS_DEPENDENT_QUESTION_TYPES.includes(questionType) && (options?.length || 0) < 2) {
      showNotification("Options error", "At-least 2 options are required", "error");
      return;
    }
    const newQuestion = {
      type: questionType,
      title: questionTitle,
      options: options,
      required: required,
      displayOrder: displayOrder
    };
    setSurveyQuestions([...surveyQuestions, newQuestion]);
    setAddNewQuestion(false);
  };

  return (
    <Card style={{ margin: "5px" }}>
      <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
        <Input
          placeholder="Enter your question"
          value={questionTitle}
          onChange={(e) => {
            setQuestionTitle(e.target.value);
          }}
          style={{ flex: "1 1 auto", minWidth: "min(200px, 100%)" }}
        />
        <Select
          defaultValue="TEXT"
          onChange={(value) => setQuestionType(value)}
          options={questionTypes}
          style={{ width: "min(200px, 100%)" }}
          popupMatchSelectWidth={false}
        />
      </div>
      <div style={{ margin: "10px" }}>
        {OPTIONS_DEPENDENT_QUESTION_TYPES.includes(questionType) && (
          <SelectOptions options={options} setOptions={setOptions} />
        )}
        <Space wrap>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            Display Order{" "}
            <Input
              onChange={(e) => setDisplayOrder(e.target.value)}
              value={displayOrder}
              style={{ width: "50px" }}
            />
          </div>
          <div>
            Required <Switch onChange={onChange} />
          </div>
          <Button
            type="primary"
            onClick={() => {
              handleAddQuestion();
            }}
          >
            Add
          </Button>
          <Button onClick={() => setAddNewQuestion(false)} danger>
            Cancel
          </Button>
        </Space>
      </div>
    </Card>
  );
};

export default QuestionGeneratorForm;
